export default "__VITE_ASSET__7cdfa89b__"